export default __webpack_public_path__ + "alberta-death.259cb56d93431e22ed35.svg";